export enum Time {
	minutesToMilliseconds = 60000,
	hoursToMilliseconds = 3600000,
	daysToMilliseconds = 86400000
}

export enum PUSH_SRC_TYPE {
	unknown = 0,
	appPush = 4,
	timed = 5,
	instantPush = 6
}

export enum TRIGGER_TYPE {
	recurring = 'recurring',
	themeChanged = 'themeChanged',
	timed = 'timed'
}

export enum CLIENT_ACTION {
	none = 'none',
	navBarClick = 'navBarClick',
	appPushFeedback = 'inAppPushFeedback',
	timedPushFeedback = 'dynamicPushFeedback',
	instantPushFeedback = 'instantPush' // should be instantPushFeedback??
}

export enum API_INIT_MODE {
	invalid = 0,
	manual = 1,
	automatic = 2
}
